"use client";

import PosterScrollContainer from "@/components/poster/PosterScrollContainer";
import PlannedShow from "@/components/program/PlannedShow";
import ProgramShow from "@/components/program/ProgramShow";
import { type ProgramShowDisplayProps } from "@/components/program/ProgramShowDisplayProps";
import ShowPosterFallback from "@/components/program/ShowPosterFallback";
import { combineShowList, type IFlatMappedPlannedDate } from "@/components/program/combineShowList";
import { ShowWithMovie } from "@/lib/client/getShowsAndMovies";
import { IPlannedDates } from "@/lib/kinologg/kinologgTypes";
import { useMemo } from "react";
import styles from "./ProgramShowDisplay.module.css";

//#region [Component]
export default function ProgramShowDisplay({ shows, isLoadingPlannedDates, plannedDates, hidePlannedDates = false, noPoster = false, className, combinePlannedDates = true }: ProgramShowDisplayProps) {
    const combinedShowList = useCombinedShowList(shows, plannedDates, hidePlannedDates, combinePlannedDates);
    return <PosterScrollContainer displayClassName={className}>
        {combinedShowList.map(show => {
            if (isPlannedDate(show)) {
                return <PlannedShow key={`${show.spillested.id}_${show.id}`} location={show.spillested} date={show} className={styles.ProgramShow} />;
            }
            else {
                return <ProgramShow key={`${show.location}_${show.showStart}`} show={show} className={styles.ProgramShow} noPoster={noPoster} />;
            }
        })}
        {hidePlannedDates === false && isLoadingPlannedDates && <ShowPosterFallback numPlaceholderPosters={1} className={styles.PlannedDatesLoader} />}
    </PosterScrollContainer>;
}
//#endregion

//#region [Hooks]
function useCombinedShowList(shows: ShowWithMovie[] | undefined, plannedDates: IPlannedDates[] | undefined, hidePlannedDates: boolean, combinePlannedDates: boolean) {
    return useMemo(() => combineShowList(shows, plannedDates, hidePlannedDates, combinePlannedDates), [shows, plannedDates, hidePlannedDates, combinePlannedDates]);
}
//#endregion

//#region [Helpers]
function isPlannedDate(show: ShowWithMovie | IFlatMappedPlannedDate): show is IFlatMappedPlannedDate {
    return ("dato" in show);
}
//#endregion